import { create } from 'zustand';

type CanvasStoreType = {
  canvas: fabric.Canvas | null;
  setCanvas: (canvas: fabric.Canvas | null) => void;
  moveObjects: boolean;
  setMoveObjects: (move: boolean) => void;
};

export const useCanvasStore = create<CanvasStoreType>((set) => ({
  canvas: null,
  setCanvas: (canvas) => {
    set({ canvas: canvas });
    if (canvas) {
      canvas?.requestRenderAll();
    }
  },
  moveObjects: false,
  setMoveObjects: (move) => set({ moveObjects: move })
}));
